import React from 'react';

const SentimentCluster = ({ selectedRegion, selectedCity, dateRange, showLocations, showProducts, showApps }) => {
  // Mock data for sentiment distribution
  // This would be calculated from actual reviews in a real implementation
  const sentimentData = [
    { name: 'Very Positive', value: 35, color: '#22c55e' },
    { name: 'Positive', value: 25, color: '#86efac' },
    { name: 'Neutral', value: 15, color: '#d1d5db' },
    { name: 'Negative', value: 15, color: '#fca5a5' },
    { name: 'Very Negative', value: 10, color: '#ef4444' }
  ];
  
  const totalReviews = sentimentData.reduce((sum, item) => sum + item.value, 0);
  
  // Calculate positive/negative ratio
  const positivePercentage = ((sentimentData[0].value + sentimentData[1].value) / totalReviews * 100).toFixed(1);
  const negativePercentage = ((sentimentData[3].value + sentimentData[4].value) / totalReviews * 100).toFixed(1);
  
  return (
    <div>
      <h2 className="text-lg font-medium text-gray-800 mb-4">Sentiment Distribution</h2>
      
      <div className="flex justify-between items-center mb-4">
        <div className="text-center">
          <div className="text-3xl font-bold text-green-600">{positivePercentage}%</div>
          <div className="text-xs text-gray-500">Positive</div>
        </div>
        
        <div className="h-12 w-px bg-gray-200"></div>
        
        <div className="text-center">
          <div className="text-3xl font-bold text-gray-600">{totalReviews}</div>
          <div className="text-xs text-gray-500">Total Reviews</div>
        </div>
        
        <div className="h-12 w-px bg-gray-200"></div>
        
        <div className="text-center">
          <div className="text-3xl font-bold text-red-600">{negativePercentage}%</div>
          <div className="text-xs text-gray-500">Negative</div>
        </div>
      </div>
      
      <div className="relative h-16 mb-6 bg-gray-100 rounded-full overflow-hidden">
        {sentimentData.map((item, index) => {
          // Calculate the position and width of this segment
          const previousWidth = sentimentData
            .slice(0, index)
            .reduce((sum, i) => sum + i.value, 0) / totalReviews * 100;
            
          const width = item.value / totalReviews * 100;
          
          return (
            <div
              key={index}
              className="absolute top-0 bottom-0"
              style={{
                left: `${previousWidth}%`,
                width: `${width}%`,
                backgroundColor: item.color
              }}
            />
          );
        })}
      </div>
      
      <div className="grid grid-cols-5 gap-2">
        {sentimentData.map((item, index) => (
          <div key={index} className="text-center">
            <div className="flex justify-center mb-1">
              <div className="w-4 h-4 rounded-full" style={{ backgroundColor: item.color }}></div>
            </div>
            <div className="text-xs font-medium">{item.value}%</div>
            <div className="text-xs text-gray-500">{item.name}</div>
          </div>
        ))}
      </div>
      
      <div className="mt-6">
        <h3 className="text-sm font-medium mb-2">Sentiment by Source</h3>
        <div className="space-y-3">
          {showLocations && (
            <div className="flex items-center">
              <div className="w-24 text-xs text-gray-600">Locations</div>
              <div className="flex-grow bg-gray-100 h-4 rounded-full overflow-hidden">
                <div className="bg-green-500 h-full" style={{ width: '72%' }}></div>
              </div>
              <div className="ml-2 text-xs font-medium">72% Positive</div>
            </div>
          )}
          
          {showProducts && (
            <div className="flex items-center">
              <div className="w-24 text-xs text-gray-600">Products</div>
              <div className="flex-grow bg-gray-100 h-4 rounded-full overflow-hidden">
                <div className="bg-green-500 h-full" style={{ width: '65%' }}></div>
              </div>
              <div className="ml-2 text-xs font-medium">65% Positive</div>
            </div>
          )}
          
          {showApps && (
            <div className="flex items-center">
              <div className="w-24 text-xs text-gray-600">Apps</div>
              <div className="flex-grow bg-gray-100 h-4 rounded-full overflow-hidden">
                <div className="bg-green-500 h-full" style={{ width: '48%' }}></div>
              </div>
              <div className="ml-2 text-xs font-medium">48% Positive</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SentimentCluster;